import { ChangeEvent, ForwardedRef, forwardRef, InputHTMLAttributes } from "react";
import cx from "classnames";

import styles from "./styles.module.css";
import getNumberFieldFixup from "./getNumberFieldFixup";

export type InputProps = {
  id?: string;
  color?: "default" | "inversed";
  size?: "small" | "regular";
  error?: boolean;
  active?: boolean;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "size" | "readOnly">;

const Input = forwardRef(function Input(props: InputProps, ref: ForwardedRef<HTMLInputElement>) {
  const {
    id,
    className,
    size = "regular",
    color = "default",
    disabled,
    onChange,
    error = false,
    type = "text",
    active,
    ...restProps
  } = props;

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange?.(e);
    }
  };

  return (
    <input
      id={id}
      ref={ref}
      onChange={handleOnChange}
      {...getNumberFieldFixup(type)}
      type={type}
      className={cx(
        styles.input,
        styles[size],
        styles[color],
        {
          [styles.error]: error,
          [styles.disabled]: disabled,
          [styles.active]: active,
        },
        className
      )}
      disabled={disabled}
      {...restProps}
    />
  );
});

Input.displayName = "DS.Input";

export default Input;
